import { render } from "./CustomNavigation.vue?vue&type=template&id=3346105f"
import script from "./CustomNavigation.vue?vue&type=script&lang=js"
export * from "./CustomNavigation.vue?vue&type=script&lang=js"

import "./CustomNavigation.vue?vue&type=style&index=0&id=3346105f&lang=scss"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__